import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["projectSelector","selectedProvider","loadingProjectSelector"]
  connect() {
  
  }
  
  getProjects() {
	 this.projectSelectorTarget.style.display = "none";
	 
	 if (this.selectedProviderTarget.value != "") {
         this.loadingProjectSelectorTarget.style.display = "block";
	     Rails.ajax({
	      type: 'GET',
	      url: "/projects/third_party_projects/"+ this.selectedProviderTarget.value,
	      dataType: 'json',
	      success: (data) => {
	        this.loadingProjectSelectorTarget.style.display = "none";
	        this.projectSelectorTarget.innerHTML = data.projectSelector
	   	    this.projectSelectorTarget.style.display = "block";
	      }
	    });
    }
    else {
	    
    }
  }  
}

